/**
 * orga-app-api - displaysteuerung-v1-oa3_1
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export const DisplaysteuerungProblemTypes = {
    DisplaysteuerungBereichNichtGefunden: 'DisplaysteuerungBereichNichtGefunden',
    DisplaysteuerungBereichGeloescht: 'DisplaysteuerungBereichGeloescht',
    DisplaysteuerungTriggerNichtGefunden: 'DisplaysteuerungTriggerNichtGefunden',
    DisplaysteuerungKeinAdminZugriff: 'DisplaysteuerungKeinAdminZugriff',
    DisplaysteuerungKeinZugriff: 'DisplaysteuerungKeinZugriff',
    DisplaysteuerungBenutzerHatKeinZugriff: 'DisplaysteuerungBenutzerHatKeinZugriff',
    DisplaysteuerungBenutzerHatKeinAdminZugriff: 'DisplaysteuerungBenutzerHatKeinAdminZugriff'
} as const;
export type DisplaysteuerungProblemTypes = typeof DisplaysteuerungProblemTypes[keyof typeof DisplaysteuerungProblemTypes];

